import { useContext } from 'react';
import { store } from 'components/Store';
import useUploadFiles from 'api/hooks/useUploadFiles';
import useLogoUrlReplacement from 'components/Dashboard/UserContent/ui/useLogoUrlReplacement';
import { getLogoBackgroundColor } from 'components/UploadHub/getLogoBackgroundColor';

const useEnsureUploadHubBranding = () => {
  const { getUploadHubBranding, updateBrandingForUploadHub } = useUploadFiles();
  const { state } = useContext(store) as unknown as { state: { team?: { organisationLogo?: string } } };
  const { replacementOfUrl } = useLogoUrlReplacement();

  const ensureBranding = async (signal?: AbortSignal) => {
    try {
      const { status } = await getUploadHubBranding({ signal });
      if (status !== 204) return;
      const logoUrl = state.team?.organisationLogo;
      if (!logoUrl) return;
      const backgroundColor = (await getLogoBackgroundColor({ logoUrl, replacementOfUrl })) ?? '#E0F0F9';
      await updateBrandingForUploadHub({ logoUrl, backgroundColor });
    } catch {
      // apiClient's error interceptor already shows a toast
    }
  };

  return { ensureBranding };
};

export default useEnsureUploadHubBranding;
